import XLSX from 'xlsx';

/* eslint-disable no-plusplus */
export default function toGenerateExcelRequest(tableElement, fileName, ignoreColumns = 0) {
  const headElements = _(tableElement.querySelectorAll("th"))
    .map(it => it); // unwrap NodeTableElementList to Array

  for (let i = 0; i < ignoreColumns; i++) {
    headElements.shift();
  }

  const rows = _(tableElement.querySelectorAll("tbody tr"))
    .chain()
    .map((it) => {
      const tds = _(it.querySelectorAll('td'))
        .map(td => td);

      for (let i = 0; i < ignoreColumns; i++) {
        tds.shift();
      }
      return _(tds)
        .map((td) => {
          let text = '';
          const input = td.querySelector('input');
          if (input) {
            text = input.value;
          }
          text += (td.innerText || '').replace('\n', '');
          return text.replace("mode_edit", "");
        });
    })
    .value();

  const heads = _(headElements)
    .map(it => it.innerText
      .replace("keyboard_arrow_up", "")
      .replace("keyboard_arrow_down", ""));

  const dateFormats = heads.map((it) => (it || '').toLowerCase()
    .indexOf('date') > -1 ? 'm/d/yyyy' : '');

  return {
    fileName,
    heads,
    dateFormats,
    cellTypes: _(headElements)
      .map(() => "STRING"),
    rows,
  };
}

export const downloadExcel = (data, sheetName, fileName) => {
  /* convert state to workbook */
  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  /* generate file and send to client */
  XLSX.writeFile(wb, fileName);
};
